<template>
  <div v-loading="loading" element-loading-text="加载中" class="wapper" >
    <wt-re-request-tip message="列表获取失败"
        :reLoad="load"
        :styles="'top:0;left:0;right:0;bottom:40px;'"
        v-show="isShowReloadTip">
    </wt-re-request-tip>
    <slot :data="currentData"/>
    <el-pagination
    :class="'paeg-'+paegLocation"
      v-if="showPagination"
      @current-change="handleCurrentChange"
      :page-size="pageSize"
      :layout="currentLayout"
      :current-page.sync = "current_page"
      :total="currentTotal"
      :background="background"
      :pager-count="pagerCount"
      :page-sizes="pageSizes"
      @size-change="handleSizeChange"
      ref="pagination">
    </el-pagination>
  </div>
</template>

<script>
/*
  基于element-ui的ajax分页列表组件，封装了分页组件以及ajax请求的交互
  用法：
  <wt-paged-table>
  <!-- 页面渲染的列表数据，可以用vue在前端进行渲染，也可以是服务器端渲染出来的数据 -->
  </wt-paged-table>
  Events:
  page-loaded
*/
import { Pagination } from 'element-ui'

export default {
  name: 'wt-paged-table',
  props: {
    onRequestData: {
      type: Function
    },
    onRequestCount: {
      type: Function
    },
    // 第一次渲染时的初始页
    initialPage: {
      type: Number,
      default: 0
    },
    totalSize: {
      type: Number,
      default: -1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    // 如果为true，则组件在mount后会自动进行一次加载
    refresh: {
      type: Boolean,
      default: false
    },
    // 是否将页码加到页面连接中
    isAddPageToRouter: {
      type: Boolean,
      default: false
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    data: {
      // 初始数据,选填，一般配合数据持久化使用，在页面刷新后，立即通过data传入数据，可立即渲染出列表
      type: Array
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next,jumper'
    },
    currentPage: {
      type: Number,
      default: 0
    },
    pagerCount: {
      type: Number,
      default: 7
    },
    paegLocation: {
      type: String,
      default: 'center'
    },
    isOutside: {// 是否外部默认调用一次列表函数
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      default: false
    },
    pageSizes: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    // 父组件是否设置了totalSize
    isTotalSizeSet () {
      return this.totalSize > -1
    },
    currentLayout () {
      return this.layout
    }
  },
  components: {
    'el-pagination': Pagination
  },
  data () {
    return {
      page: this.initialPage,
      current_page: this.currentPage,
      loading: false,
      loadOnMounted: this.refresh,
      currentTotal: this.totalSize > -1 ? this.totalSize : 0,
      currentData: this.data || [],
      isShowReloadTip: false,
      page_size:this.pageSize
    }
  },
  watch: {
    'totalSize' (val) {
      this.currentTotal = val
      let maxPage = val / this.pageSize
      let queryData = this.$route.query
      if (val < 0 || val === 0) {
        this.page = this.initialPage
        this.$router.replace({ name: this.$route.name, query: { ...queryData, page: 1 } })
      } else {
        let queryPage = this.initialPage === 0 ? (maxPage - 1) : maxPage
        if (this.isAddPageToRouter && (val % this.pageSize === 0 && this.page > queryPage)) {
          this.page = queryPage
          this.$router.replace({ name: this.$route.name, query: { ...queryData, page: maxPage } })
          // this.load()
        }
      }
    },
    'refresh' (val, oldValue) {
      this.loadOnMounted = val
    },
    currentPage (val) {
      this.current_page = val
    }
  },
  methods: {
    handleSizeChange (val) {
      this.page_size=val
      this.page = 0
      this.current_page = 1
      this.$emit('size-change', val)
      let queryData = this.$route.query
      this.$router.replace({ name: this.$route.name, query: { ...queryData, page: 1 } })
      this.load()
    },
    handleCurrentChange: function (currentPage) {
      this.page = this.initialPage === 0 ? currentPage - 1 : currentPage
      if (this.isAddPageToRouter) {
        let queryData = this.$route.query
        this.$router.replace({ name: this.$route.name, query: { ...queryData, page: currentPage } })
      }
      this.$emit('handleCurrentChange', currentPage)
      this.load()
    },
    resetPage () {
      this.current_page = 1
      this.$refs.pagination.lastEmittedPage = 1
      this.handleCurrentChange(this.current_page)
    },
    load () {
      this.loading = true
      if (this.totalSize < 0) {
        this.onRequestCount && this.onRequestCount((totalCount) => {
          this.currentTotal = totalCount
          this.lodeRequestData()
        })
      } else {
        this.lodeRequestData()
      }
    },
    lodeRequestData () {
      this.onRequestData && this.onRequestData(this.page, (data) => {
        this._fullData(data)
        this.loading = false
      },this.page_size)
    },
    // 覆盖当前数据
    _fullData (data) {
      if (this._check(data)) {
        this.currentData = data
        this.isShowReloadTip = false
      }
    },
    // 检查传入的数据是否符合要求（数组）
    _check (data) {
      if (Array.isArray(data)) {
        return true
      } else {
        console.warn('列表数据必须为数组！')
        return false
      }
    },
    showReTry () {
      this.isShowReloadTip = true
      this.loading = false
    }
  },
  created () {
    // 对传入的属性做一定的校验
    if (!this.isTotalSizeSet) {
      if (!this.onRequestCount) {
        console.error('无法获取数据总条数！请传入totalSize，或者设置onRequestCount！')
      }
    }
    let queryData = this.$route.query
    if (this.isAddPageToRouter && queryData && queryData.page) {
      this.current_page = Number(queryData.page)
      this.page = this.initialPage === 0 ? (Number(queryData.page) - 1) : Number(queryData.page)
      this.$emit('handleCurrentChange', Number(queryData.page))
    }
    this.load()
  }
}
</script>
<style lang="less">
  .el-pagination{
    display: flex;
    justify-content:center;
    margin-top: 10px;
    padding:5px 10px;
  }
  .wapper{
    position:relative;
  }
  .paeg-left{
    justify-content:flex-start;
  }
   .paeg-right{
    justify-content:flex-end;
  }
</style>
